import { Component, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbInputDatepicker,
} from '@ng-bootstrap/ng-bootstrap';
import { FromTo } from '@models/common/from-to.model';
import moment from 'moment/moment';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeComponent),
      multi: true,
    },
  ],
})
export class DateRangeComponent implements ControlValueAccessor {
  formatter = inject(NgbDateParserFormatter);
  calendar = inject(NgbCalendar);

  private start = moment().startOf('month');
  private end = moment().endOf('month');

  from: NgbDate | null = new NgbDate(
    this.start.year(),
    this.start.month(),
    this.start.days()
  );
  to: NgbDate | null = new NgbDate(
    this.end.year(),
    this.end.month(),
    this.end.days()
  );

  hovered: NgbDate | null = null;

  dateSelect(date: NgbDate, datepicker: NgbInputDatepicker) {
    if (!this.from && !this.to) {
      this.from = date;
    } else if (this.from && !this.to && date && date.after(this.from)) {
      this.to = date;
    } else {
      this.to = null;
      this.from = date;
    }
    if (this.from && this.to) {
      this.change();
      datepicker.close();
    }
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.from) ||
      (this.to && date.equals(this.to)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isInside(date: NgbDate) {
    return this.to && date.after(this.from) && date.before(this.to);
  }

  isHovered(date: NgbDate) {
    return (
      this.from &&
      !this.to &&
      this.hovered &&
      date.after(this.from) &&
      date.before(this.hovered)
    );
  }

  writeValue(value: FromTo | null): void {
    if (value) {
      this.from = value.from;
      this.to = value.to;
    }
  }

  private onChanged!: any;
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  private onTouched!: any;
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  change() {
    this.onTouched();
    this.onChanged({ from: this.from, to: this.to } as FromTo);
  }

  format(date: NgbDateStruct | null): string {
    if (date) {
      const dt = moment({
        year: date.year,
        month: date.month - 1, // Moment.js months are 0-indexed
        day: date.day,
      });
      return dt.format('MM-DD-YYYY');
    }
    return '';
  }
}
